import DeveloperActionTypes from 'app/developer/ActionTypes';
import routes from 'app/developer/routes';

export default {
  actionTypes: DeveloperActionTypes,
  routes,
};
